export default "__VITE_ASSET__C6i268qR__"